module.exports = __webpack_public_path__ + "static/media/adult-apple-device-business-340152.0c4c9be6.jpg";